import { size } from '~tokens/global';

const OVERLAY_OFFSET: number = size['8'];
const OVERLAY_TRANSITION_OFFSET: number = size['8'];

export { OVERLAY_OFFSET, OVERLAY_TRANSITION_OFFSET };
